import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./index.css";
import App from "./App";
import AdminDashboard from "./AdminDashboard";
import reportWebVitals from "./reportWebVitals";

/** CRA `homepage` / `PUBLIC_URL` (e.g. `/my-repo`). Required so `/my-repo/admin` matches the admin route. */
function routerBasename() {
  const raw = process.env.PUBLIC_URL;
  if (raw == null) return undefined;
  const s = String(raw).trim();
  if (s === "" || s === "/") return undefined;
  return s.endsWith("/") ? s.slice(0, -1) : s;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter basename={routerBasename()}>
      <Routes>
        <Route path="admin" element={<AdminDashboard />} />
        <Route path="*" element={<App />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
